export const CARD_SIZE_SMALL = 0;
export const CARD_SIZE_MEDIUM = 1;
export const CARD_SIZE_LARGE = 2;



// WEBPACK FOOTER //
// ./app/constants/card-sizes.js